import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import RegisterHook from "../../hook/auth/RegisterHook";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";
import { useTranslation } from "react-i18next";

const RegisterPage = () => {
  const { t } = useTranslation();

  const [
    firstname,
    lastname,
    mobile,
    email,
    password,
    confirmPassword,
    acceptTerms,
    loading,
    onChangeFirstname,
    onChangeLastname,
    onChangeMobile,
    onChangeEmail,
    onChangePassword,
    onChangeConfirmPassword,
    onChangeAcceptTerms,
    onSubmit,
  ] = RegisterHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

  return (
    <div className="cart-page-bg font" style={{ minHeight: "100vh", display: "flex", alignItems: "center", padding: "40px 0" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg="5" md="7" sm="10" xs="12">
            <div className="checkout-section-card" style={{ padding: "40px 32px" }}>

              {/* Header */}
              <div className="text-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: `${primaryColor}15` }}>
                  <i className="fa-solid fa-user-plus" style={{ fontSize: '1.5rem', color: primaryColor }}></i>
                </div>
                <h4 className="fw-bold text-dark mb-1">{t("create new account")}</h4>
              </div>

              {/* Form */}
              <Row>
                <Col xs={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted fw-bold small">{t("first name")}</label>
                    <input value={firstname} onChange={onChangeFirstname} placeholder={t("first name")} type="text" className="form-control bg-light border-0 py-2 font" />
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted fw-bold small">{t("last name")}</label>
                    <input value={lastname} onChange={onChangeLastname} placeholder={t("last name")} type="text" className="form-control bg-light border-0 py-2 font" />
                  </div>
                </Col>
              </Row>

              <div className="mb-3">
                <label className="form-label text-muted fw-bold small">{t("email")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-envelope position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input value={email} onChange={onChangeEmail} placeholder={t("email")} type="email" className="form-control bg-light border-0 py-2 font" style={{ paddingRight: '40px' }} />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label text-muted fw-bold small">{t("phone")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-phone position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input value={mobile} onChange={onChangeMobile} placeholder={t("phone")} type="phone" className="form-control bg-light border-0 py-2 font text-start" dir="ltr" style={{ paddingRight: '40px' }} />
                </div>
              </div>

              <Row>
                <Col xs={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted fw-bold small">{t("password")}</label>
                    <input value={password} onChange={onChangePassword} placeholder={t("password")} type="password" className="form-control bg-light border-0 py-2 font" />
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted fw-bold small">{t("confirm password")}</label>
                    <input value={confirmPassword} onChange={onChangeConfirmPassword} placeholder={t("confirm password")} type="password" className="form-control bg-light border-0 py-2 font" />
                  </div>
                </Col>
              </Row>

              {/* Terms */}
              <div className="mb-4 d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={onChangeAcceptTerms}
                  className="form-check-input"
                  style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                />
                <Link to={`/terms/${1}`} className="text-decoration-underline small fw-bold" style={{ color: primaryColor }}>
                  {t("agree terms")}
                </Link>
              </div>

              {/* Submit */}
              <button
                onClick={onSubmit}
                className="btn w-100 text-white fw-bold py-3 border-0 font"
                style={{ backgroundColor: primaryColor, borderRadius: '10px', fontSize: '1.05rem' }}
                disabled={!loading}
              >
                {!loading ? <LoadingSpinner /> : t("create account")}
              </button>

              {/* Login Link */}
              <div className="text-center mt-4">
                <span className="text-muted small">{t("already have account")} </span>
                <Link to="/login" className="text-decoration-none fw-bold small" style={{ color: primaryColor }}>
                  {t("click here")}
                </Link>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegisterPage;
